import { render, staticRenderFns } from "./modal-attach-contacts.vue?vue&type=template&id=463a15e7&scoped=true&"
import script from "./modal-attach-contacts.vue?vue&type=script&lang=js&"
export * from "./modal-attach-contacts.vue?vue&type=script&lang=js&"
import style0 from "./modal-attach-contacts.vue?vue&type=style&index=0&id=463a15e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463a15e7",
  null
  
)

export default component.exports